import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CreateIssuerUserDto } from '../_dtos/create-issuer-user.dto';
import { AppLocalStorage } from 'src/app/storage-manager/local-storage';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient, private appLocalStorage: AppLocalStorage,private sharedService: SharedService) { }

  getIssuerUsers() {
    let user = this.appLocalStorage.getFromStorage('DASHBOARD_CONFIG')
    if(!user.issuer){
      return this.http.get(`${environment.ADMIN_REPORT_URL}/admin/allusers?isocode=${this.sharedService.getSelectedCountryFromSession()}`);
    }

    else
     return this.http.get(`${environment.ADMIN_REPORT_URL}/user/issuer-user`);
  }

  createIssuerUser(createIssuerUserDto: CreateIssuerUserDto) {
    let user = this.appLocalStorage.getFromStorage('DASHBOARD_CONFIG')
    if(!user.issuer)
      return this.http.post(`${environment.ADMIN_REPORT_URL}/admin/createUser`, createIssuerUserDto);
    else
      return this.http.post(`${environment.ADMIN_REPORT_URL}/user/issuer-user`, createIssuerUserDto);
  }

  deleteIssuerUser(issuerUserId: string) {
    let user = this.appLocalStorage.getFromStorage('DASHBOARD_CONFIG')
    if(!user.issuer)
      return  this.http.delete(`${environment.ADMIN_REPORT_URL}/admin/${issuerUserId}`);
    else
      return this.http.delete(`${environment.ADMIN_REPORT_URL}/user/issuer-user/${issuerUserId}`);
  }

  updateIssuerUser(issuerUserId: string, updateIssuerUserDto: CreateIssuerUserDto) {
    let user = this.appLocalStorage.getFromStorage('DASHBOARD_CONFIG')
    if(!user.issuer)
      return this.http.patch(`${environment.ADMIN_REPORT_URL}/admin/${issuerUserId}`, updateIssuerUserDto);
    else
      return this.http.put(`${environment.ADMIN_REPORT_URL}/user/issuer-user/${issuerUserId}`, updateIssuerUserDto);
  }

  fetchMerchantTransactionSummary(merchant_id: string, country_code: string, start_date: string, end_date: string):Observable<any> {
    return this.http.get(`${environment.XAS_URL}/admin/transactions/summary/users/${country_code}?merchant_id=${merchant_id}&start_date=${start_date}&end_date=${end_date}`);
  }

    unlockAccount(data: any): Observable<any>{
    return this.http.post(`${environment.ADMIN_AUTH_URL}/admin/unlock-account`, data);
}


}
